import { Component, OnInit, OnDestroy, AfterViewChecked, ViewChild } from '@angular/core';
import { PlacementService, AuthenticationService, UserService } from "../_services/index";
import { ActivatedRoute, Router } from "@angular/router";
import { FeatureHelperService } from '../_helpers/feature-helper/feature-helper.service';
import { TutorReportsHelperService } from '../_helpers/tutor-reports-helper/tutor-reports-helper.service';
import { UtilityBarHelperService } from '../_helpers/utility-bar-helper/utility-bar-helper.service';
import { PlacementData } from '../_models';
import { ErrorModalHelperService } from '../_helpers/error-modal-helper/error-modal-helper.service';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
@Component({
    selector: 'tutor-reports',
    templateUrl: 'tutor-reports.component.html',
    standalone: false
})
export class TutorReportsComponent implements OnInit, OnDestroy, AfterViewChecked {

  @ViewChild("report") childUtilityRefComponent: any;
  loaded: boolean = false;
  private utilityBarBound: boolean = false;
  constructor(
    private featureHelperService: FeatureHelperService,
    private tutorReportsHelperService: TutorReportsHelperService,
    private utilityBarHelper: UtilityBarHelperService,
    private placementService: PlacementService,
    private router: Router,
    private route: ActivatedRoute,
    private errorModalHelper: ErrorModalHelperService,
    private authService: AuthenticationService,
    private userService: UserService
  ) {
  }

  ngOnDestroy(): void {
  }

  ngAfterViewChecked(): void {
    if (!this.utilityBarBound && this.childUtilityRefComponent) {
      this.utilityBarBound = true;
      this.utilityBarHelper.triggerUtilityBarRefresh();
    }
  }

  ngOnInit() {
    let featureList = new Array<string>();
    featureList.push("TutorReportsView");

    let currentUserFeatures = this.featureHelperService.checkFeaturePermissions(featureList);

    if (!currentUserFeatures.filter(f => f.feature === "TutorReportsView")[0].enabled) {
      console.error("User does not have th required permissions to view the tutor reports screen");
      this.router.navigate(['/login'], { queryParams: { returnUrl: window.location.pathname } });
    }

    this.populatePage();

  }

  private populatePage() {

    // The placement id now lives in the route (/tutorreports/:id) so the screen is deep-linkable.
    // Establish the shared context from it before falling back to the redirect guard.
    const routeId = Number(this.route.snapshot.paramMap.get('id'));
    if (!isNaN(routeId) && routeId > 0) {
      this.tutorReportsHelperService.ensureContext(routeId);
    }

    if (this.tutorReportsHelperService.commonData == null || this.tutorReportsHelperService.commonData.placementId == null) {
      this.router.navigate(["/"]);
    } else {

      this.tutorReportsHelperService.commonData.applicationUserId = this.authService.userSessionData.currentUser.applicationUserId

      forkJoin({
        data: this.placementService.getById(this.tutorReportsHelperService.commonData.placementId),
        admin: this.userService.getByRole('ADMIN').pipe(catchError(() => of([])))
      }).subscribe({
        next: ({ data, admin }: { data: PlacementData, admin: any[] }) => {
          if (admin != null && admin.length > 0) {
            data.adminMobile = admin[0].mobileNumber;
            data.adminEmail = admin[0].email;
          }

          this.tutorReportsHelperService.commonData.placementStartDate = data.placementStartDate;
          this.tutorReportsHelperService.commonData.placementEndDate = data.placementEndDate;
          
          this.tutorReportsHelperService.setPlacementData(data);

          this.loaded = true;
        },
        error: error => {
          let errorMessage = error.status === 401 ? "Unauthorized" : error.message;
          if (errorMessage == "Object reference not set to an instance of an object.") {
            errorMessage = "Client not found. Try another."
          }
          this.errorModalHelper.show(errorMessage, error);
        }
      });

    }
  }

}
